import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isFileNameAllowed } from '@platform/shared/utilities/file-utility';

export function requireValidFilename(invalidChars: string[]): ValidatorFn {
  return (control: AbstractControl) => {
    const filename: unknown = control.value;
    if (typeof filename === 'string' && !isFileNameAllowed(filename, invalidChars)) {
      return { invalidFilename: true };
    }
    return null;
  };
}
